import { createClient } from "@supabase/supabase-js";

export const supabase = createClient(
  "https://boyrcydkwemtnpfsvtas.supabase.co",
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJveXJjeWRrd2VtdG5wZnN2dGFzIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzI5MjU5MjEsImV4cCI6MjA0ODUwMTkyMX0.a9Kf8_GB3oRZXEs7hpGMHVwhkmQ7r4P9CQznoDsVeC0"
);
